<template>
  <default-step-container v-on="containerListeners" :required="false">
    <template #question>{{ question }}</template>
    <template #default>
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">
          <div v-if="state === 'sending'" class="alert alert-info text-center">
            Senden des Bewerbungsformulars.
          </div>
          <div v-if="state === 'failed'" class="alert alert-danger text-center">
            Das Antragsformular konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.
          </div>
          <div v-if="state === 'success'" class="alert alert-success text-center">
            Ihre Bewerbung wurde erfolgreich
            übermittelt. Vielen Dank! Wir prüfen Ihre Bewerbung und melden uns in den kommenden 10 Tagen
            bei Ihnen zurück.
          </div>
        </div>
      </div>
    </template>
  </default-step-container>
</template>
<script>
import DefaultStep from './DefaultStep'
import axios from 'axios'

export default {
  extends: DefaultStep,

  data() {
    return {
      state: 'sending'
    }
  },

  mounted () {
    this.submit()
  },

  methods: {
    submit () {
      axios.post(process.env.VUE_APP_API, this.formAsPayload(), {
        auth: {
          username: process.env.VUE_APP_USERNAME,
          password: process.env.VUE_APP_PASSWORD
        }
      }).then(() => this.success())
      .catch(this.failed)
    },

    formAsPayload () {
      return new FormData()
    },

    failed (e) {
      this.state = 'failed'
      if (process.env.NODE_ENV === 'development') {
        console.log(e)
      }
    },

    success () {
      this.state = 'success'
    }
  }
}
</script>
